import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: Index,
    meta: {
      isBack: false
    }
  },

  
]

const router = new VueRouter({
  routes
})


export default router
